function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallbackWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.88,6.26a1.32,1.32,0,0,0-1.07.64,2.58,2.58,0,0,0-.35,1.36C5.57,9.46,7,10.46,7.82,11c7.71,5.23,5.78,5.64,11.63,1.43,1.28-.93,3.07-1.86,3.85-3a2.27,2.27,0,0,0,.15-2.64c-.58-.64-1.08-.56-1.94-.56H8.57A15.89,15.89,0,0,0,6.88,6.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.65,20.41a3,3,0,0,0-2.14-.93,3.17,3.17,0,0,0-3.14,3.15,3,3,0,0,0,.42,1.63H18.51a3.92,3.92,0,0,0,.43-1.57,3.13,3.13,0,0,0-5.35-2.24,3.37,3.37,0,0,0-.86,2.24,3.2,3.2,0,0,0,.86,2.14,3.1,3.1,0,0,0,2.24.93h7.68a3.12,3.12,0,0,0,3-3.2,3.21,3.21,0,0,0-.9-2.11ZM17,23.67a1.67,1.67,0,0,1-1.15.49,1.71,1.71,0,0,1-1.57-1.57,1.54,1.54,0,0,1,.5-1.14A1.49,1.49,0,0,1,15.85,21a1.54,1.54,0,0,1,1.64,1.43A1.48,1.48,0,0,1,17,23.67Zm7.56,0a1.46,1.46,0,0,1-1.07.49,1.5,1.5,0,0,1-1.14-.49,1.45,1.45,0,0,1-.43-1.08A1.5,1.5,0,0,1,23.32,21h.17a1.47,1.47,0,0,1,1.07.43A1.57,1.57,0,0,1,25,22.59a1.62,1.62,0,0,1-.45,1.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.94,20.67h-.07a2.93,2.93,0,0,0-.81-1.07,4.25,4.25,0,0,0-3-1.29,4.34,4.34,0,0,0-3,1.29,3.82,3.82,0,0,0-.75,1.07H7.16a1.63,1.63,0,0,1-1.64-1.29A8,8,0,0,1,5.46,18V10.89c1.42,1.34,7.77,5.84,9.2,5.84s7.71-4.5,9.14-5.85v7.38h0A4.29,4.29,0,0,0,19.94,20.67Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallbackWhite);
export default __webpack_public_path__ + "static/media/callback-white.2853c5c2.svg";
export { ForwardRef as ReactComponent };